import { Reference } from '@approvalmax/types';
import { domain } from 'modules/data';

import { messages } from './OrganisationInfo.messages';
import { EnforcementOption } from './OrganisationInfo.types';

export const enforcementOptions: EnforcementOption[] = [
    {
        id: domain.TwoFaEnforcementType.None,
        text: messages.enforcementTwoFaOptionNone,
    },
    {
        id: domain.TwoFaEnforcementType.Soft,
        text: messages.enforcementTwoFaOptionSoft,
    },
    {
        id: domain.TwoFaEnforcementType.Hard,
        text: messages.enforcementTwoFaOptionHard,
    },
];

export const netSuiteTaxCodeListsIncludeValues: Reference[] = [
    {
        id: 'TaxCodesOnly',
        text: messages.taxCodesOnlyValue,
    },
    {
        id: 'TaxGroupsOnly',
        text: messages.taxGroupsOnlyValue,
    },
    {
        id: 'TaxGroupsAndTaxCodes',
        text: messages.taxGroupsAndTaxCodesValue,
    },
];
